import ProjectManagmentDashboardTemplate from "Components/templates/project-managment/dashboard";

const ProjectManagmentDashboard = () => {
    document.title = "Project Managment Dashboard | IbexIQ";
    return <ProjectManagmentDashboardTemplate />
}

export default ProjectManagmentDashboard;